import type { AuthStyles } from '../../../../theme/themes/ThemeTypes';
import colors from '../colors';
import fonts from '../fonts';

/**
 * Auth theme styling that matches the auth/styles.scss file
 * Provides styled-components compatible theme objects
 */
const auth: AuthStyles = {
  authenticatorError: {
    position: 'fixed',
    zIndex: 1000,
    width: '100%',
    padding: '20px 30px',
    color: colors.white,
    backgroundImage: colors.gradients.warning,
    fontWeight: fonts.fontWeights.bold,
    borderRadius: '3px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.4)',
  },
  loginBackground: {
    minHeight: '100vh',
    minWidth: '100vw',
  },
  card: {
    maxWidth: '475px',
    width: '100%',
    a: {
      textDecoration: 'underline',
      '&:hover': {
        color: colors.primaryHover,
      },
    },
    'nav a': {
      textDecoration: 'none !important',
    },
    hr: {
      borderTopColor: colors.light,
    },
    signupText: {
      fontWeight: fonts.fontWeights.demi,
      '${max.sm}': {
        fontSize: '14px',
      },
    },
    terms: {
      fontSize: fonts.fontSizes.sm,
      p: {
        fontSize: fonts.fontSizes.sm,
        lineHeight: '16px',
      },
      a: {
        textDecoration: 'none',
        lineHeight: '16px',
        '&:hover': {
          textDecoration: 'underline !important',
        },
      },
    },
    notFoundText: {
      fontSize: fonts.fontSizes.sm,
      a: {
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline !important',
        },
      },
    },
    verificationInputContainer: {
      display: 'flex',
      flexDirection: 'column',
      verificationInputCharacters: {
        width: '100%',
        height: '60px',
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gridGap: '11px',
      },
      verificationInputCharacter: {
        lineHeight: '60px',
        fontSize: '50px',
        border: `1px solid ${colors.light}`,
        textAlign: 'center',
        borderRadius: '11px',
        color: colors.dark,
        '&.verification-input-character--inactive': {
          color: colors.light,
        },
      },
      'verification-input-character--inactive': {
        backgroundColor: colors.offWhite,
        boxShadow: 'none',
      },
      'verification-input-character--selected': {
        borderColor: colors.primary,
        outline: `${colors.primary} 2px`,
        backgroundColor: colors.white,
        '&::before': {
          color: colors.black,
          content: "'|'",
          animationName: 'blink',
          animationDuration: '500ms',
          animationIterationCount: 'infinite',
          opacity: 1,
        },
        '@keyframes blink': {
          from: {
            opacity: 1,
          },
          to: {
            opacity: 0,
          },
        },
      },
    },
    meterCodeWrapper: {
      marginBottom: '30px',
      verificationInputContainer: {
        verificationInputCharacters: {
          gridTemplateColumns: 'repeat(4, 1fr)',
          gridGap: '11px',
          height: '95px',
        },
        verificationInputCharacter: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginLeft: 0,
        },
      },
    },
  },
  mediaQueries: {
    '${max.xs}': {
      verificationInputCharacters: {
        height: '50px',
        verificationInputCharacter: {
          lineHeight: '50px',
          fontSize: '30px',
        },
      },
    },
  },
  orPanel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    orText: {
      fontSize: '14px',
      margin: '0 18px',
      '${min.sm}': {
        fontSize: '16px',
      },
    },
    hr: {
      width: '100%',
      borderTop: `1px solid ${colors.light}`,
    },
  },
};

export default auth;
